import { withAlpha } from './color.ts'

/**
 * The photo viewer's own colours — the one surface in the app that is dark in **both** schemes.
 *
 * A full-bleed viewer is its own chrome, not a themed screen: a photograph is judged against black,
 * and the controls over it have to read on any picture. So the backdrop and the ink do not follow
 * the theme, and they live here, in `tokens/`, rather than as literals in the component
 * (`package-rules.test.ts` keeps colour literals out of everything else). `buildColors` and
 * `ThemeColors` are untouched: these are standalone constants, imported by `PhotoViewer` alone.
 */
export const VIEWER_COLORS = {
  /** Behind the picture. */
  backdrop: '#000000',
  /** The caption and the glyphs of the controls. */
  ink: '#ffffff',
  /** A control's own disc, so it reads over a white photograph. */
  control: withAlpha('#ffffff', 0.18),
  /** A control that cannot be pressed (zoom out at 1×). */
  controlDisabled: withAlpha('#ffffff', 0.08),
  /** The failure sentence and the "loading" hint on the empty backdrop. */
  mutedInk: withAlpha('#ffffff', 0.78),
} as const
